import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {Store, WallpaperState} from './store';

@Injectable({ providedIn: 'root' })
export class WallpaperQuery extends QueryEntity<WallpaperState> {

  constructor(protected store: Store) {
    super(store);
  }

}
